var _rect, _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 7,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_55_1185)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_55_1185)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.6416,
    y: 9.14197,
    width: 59.7531,
    height: 59.7531,
    rx: 29.8765,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.444 22.5988L44.3286 26.5257C45.0789 29.8565 47.6801 32.4577 51.0109 33.208L54.9378 34.0926L51.0109 34.9772C47.6801 35.7275 45.0789 38.3286 44.3286 41.6595L43.444 45.5864L42.5594 41.6595C41.8091 38.3286 39.208 35.7275 35.8771 34.9772L31.9502 34.0926L35.8771 33.208C39.208 32.4577 41.8091 29.8565 42.5594 26.5257L43.444 22.5988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.444 22.5988L44.3286 26.5257C45.0789 29.8565 47.6801 32.4577 51.0109 33.208L54.9378 34.0926L51.0109 34.9772C47.6801 35.7275 45.0789 38.3286 44.3286 41.6595L43.444 45.5864L42.5594 41.6595C41.8091 38.3286 39.208 35.7275 35.8771 34.9772L31.9502 34.0926L35.8771 33.208C39.208 32.4577 41.8091 29.8565 42.5594 26.5257L43.444 22.5988Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3085 39.0186L30.9404 41.8235C31.4763 44.2027 33.3343 46.0606 35.7134 46.5966L38.5184 47.2284L35.7134 47.8603C33.3343 48.3962 31.4763 50.2542 30.9404 52.6334L30.3085 55.4383L29.6767 52.6334C29.1407 50.2542 27.2828 48.3962 24.9036 47.8603L22.0986 47.2284L24.9036 46.5966C27.2828 46.0606 29.1407 44.2027 29.6767 41.8235L30.3085 39.0186Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_55_1185",
    x: 0.141602,
    y: 0.641968,
    width: 76.7529,
    height: 76.7531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_55_1185"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_1185",
    x1: 6,
    y1: 7,
    x2: 70,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#216AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B949B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FB7901"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantBig);
export default __webpack_public_path__ + "static/media/ai-assistant-big.a71bbc9b219142ff3e195874395cec54.svg";
export { ForwardRef as ReactComponent };